import { inboundShipmentIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const deleteShipment = {
  name: "deleteShipment" as const,
  input: z.object({ shipmentId: inboundShipmentIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
